import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getInvoices} from '../../../apis/leader/getInvoices'

const pageSize = 10
const useQueryGetInvoices = (currentPage: number = 1) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.copyTrading.getInvoices(),
        queryFn: async () => {
            const {data, pageInfo} = await getInvoices(pageSize, currentPage)
            return {data, pageInfo}
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    })

    return {data, refetch}
}

export default useQueryGetInvoices
